import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpEvent,
  HttpHeaders,
  HttpRequest,
  HttpResponse,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({ providedIn: "root" })
export class ActasAdminService {
  constructor(protected http: HttpClient) {}

  public get(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.serverUrl}api/actasadmin/get`);
  }

  public getTrabajadores(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.serverUrl}api/actasadmin/getTrabajadores`
    );
  }

  public getHistorialChofer(i: string): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.serverUrl}api/actasadmin/getHistorialChofer`,
      { params: { i } }
    );
  }

  public add(defa: any): Observable<any> {
    const options = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    };
    return this.http.post<any>(
      `${environment.serverUrl}api/actasadmin/add`,
      defa,
      options
    );
  }

  public addCombu(defa: any): Observable<any> {
    const options = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    };
    return this.http.post<any>(
      `${environment.serverUrl}api/actasadmin/addCombu`,
      defa,
      options
    );
  }
  public addPhoto(asm: string, foto: File): Observable<HttpEvent<any>> {
    const formData = new FormData();
    formData.append("asm", String(asm));
    if (foto) {
      formData.append("foto", foto, "foto");
    }

    const uploadReq = new HttpRequest(
      "POST",
      `${environment.serverUrl}api/actasadmin/addPhoto`,
      formData
    );
    return this.http.request<any>(uploadReq);
  }

  public getPdf(i: string): Observable<HttpResponse<Blob>> {
    return this.http.get(`${environment.serverUrl}api/actasadmin/pdf`, {
      params: { i },
      responseType: "blob",
      observe: "response",
    });
  }
  public getPhothos(i: string): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.serverUrl}api/actasadmin/getPhothos`,
      { params: { i } }
    );
  }

  public reject(i: string): Observable<any> {
    const options = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
      params: { i },
    };
    return this.http.get<any>(
      `${environment.serverUrl}api/actasadmin/reject`,
      options
    );
  }
  public accept(i: string): Observable<any> {
    const options = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
      params: { i },
    };
    return this.http.get<any>(
      `${environment.serverUrl}api/actasadmin/accept`,
      options
    );
  }
}
